import React from 'react'
import { Paper, Grid, Typography, TextField, CircularProgress, Button } from '@material-ui/core'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Cookie from 'js-cookie'
import { useHistory } from 'react-router-dom'
import { changePassword } from '../../api'
import useStyles from './styles'
import { useStore } from '../../context/Context'


const ChangePassword = () => {
  const classes = useStyles()
  const history = useHistory()
  const { setIsLoading, isLoading, setMessage } = useStore()

  const { handleSubmit, getFieldProps, errors, touched } = useFormik({
    initialValues: {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required('This field is a must!').min(8, 'Minimum of 8 characters!'),
      newPassword: Yup.string().required('This field is a must!').min(8, 'Minimum of 8 characters!'),
      confirmNewPassword: Yup.string().required('This field is a must!').oneOf([Yup.ref('newPassword'), null], 'Passwords must match!')
    }),
    onSubmit: async (values, actions) => {
      setIsLoading(true)
      try {
        const token = await Cookie.get('token')
        await changePassword({
          current_password: values.currentPassword,
          new_password: values.newPassword,
          new_confirm_password: values.confirmNewPassword
        }, token)
        actions.resetForm()
        setMessage(state => ({
          ...state,
          msg: 'Your password has changed successfully',
          severty: 'success',
          open: true
        }))
        history.replace('/')
        setIsLoading(false)
      } catch (error) {
        console.log(error)
        setMessage(state => ({
          ...state,
          msg: error.message,
          severty: 'error',
          open: true,
          link: '/changePassword'
        }))
        setIsLoading(false)
      }
    }
  })

  return (
    <main className={classes.root}>
      <form onSubmit={handleSubmit} autoComplete="off">
        <Paper elevation={0} className={classes.paper}>
          {isLoading ? (
            <Grid container justifyContent="center" alignItems="center" className={classes.loading}>
              <CircularProgress />
            </Grid>
          ) : (
            <>
              <Grid container direction="column" spacing={3}>
                <Grid item>
                  <Typography variant="h5" align="center" className={classes.sectionText}>Change Password</Typography>
                </Grid>
                <Grid item container direction="column">
                  <TextField variant="outlined" type="password" label="Current Password" {...getFieldProps('currentPassword')} />
                  {touched.currentPassword && errors.currentPassword ? <Typography variant="caption" color="error">{errors.currentPassword}</Typography> : null}
                </Grid>
                <Grid item container direction="column">
                  <TextField variant="outlined" type="password" label="New Password" {...getFieldProps('newPassword')} />
                  {touched.newPassword && errors.newPassword ? <Typography variant="caption" color="error">{errors.newPassword}</Typography> : null}
                </Grid>
                <Grid item container direction="column">
                  <TextField variant="outlined" type="password" label="Confirm New Password" {...getFieldProps('confirmNewPassword')} />
                  {touched.confirmNewPassword && errors.confirmNewPassword ? <Typography variant="caption" color="error">{errors.confirmNewPassword}</Typography> : null}
                </Grid>
                <Grid item>
                  <Button variant="contained" type="submit" className={classes.buttonSubmit}>Change Password</Button>
                </Grid>
              </Grid>
            </>
          )}
        </Paper>
      </form>
    </main>
  )
}

export default ChangePassword
